import React, { FC } from "react";
import { UserInfo } from "src/components/UserInfo";
import { IUser } from "src/@types/users";
import { DefaultDealRequestHead } from "./DefaultDealRequestHead";
import { ActionButtons } from "./ActionButtons";

interface Props {
  dealId: number;
  userInfo: IUser;
  title: string;
  main_photo: string;
  chat: number;
  is_host: boolean;
}

export const DefaultDealRequest: FC<Props> = ({
  dealId,
  userInfo,
  title,
  main_photo,
  chat,
  is_host,
}) => (
  <div className="flex flex-col gap-5 bg-purple-lighter w-full px-3 py-5 sm:p-6 xl:p-10 mt-3 xl:mt-0 rounded-20">
    <DefaultDealRequestHead
      title={title}
      main_photo={main_photo}
      chatId={chat}
    />

    <UserInfo className="bg-gray-light" userInfo={userInfo} />
    {!is_host && <ActionButtons dealId={dealId} />}
  </div>
);
